class FantasticTabs extends HTMLElement {
  constructor() {
    super();
    this.buttons = this.querySelectorAll(".ff-tab-button");
    this.slides = this.querySelectorAll(".ff-slide-featured");
    this.buttonsEvents();
  }
  buttonsEvents() {
    this.buttons.forEach((element) => {
      element.addEventListener("click", () => {

        this.deleteActivesSlides();
        this.deleteActives();
        element.classList.add("ff-active-tab");
        this.querySelector(`.${element.dataset.handle}`).classList.add(
          "ff-active-slide"
        );
      });
    });
  }
  deleteActives() {
    this.buttons.forEach((element) => {
      element.classList.remove("ff-active-tab");
    });
  }
  deleteActivesSlides() {
    this.slides.forEach((element) => {
      element.classList.remove("ff-active-slide");
    });
  }
}
customElements.define("fantastic-tabs", FantasticTabs);